import { createStore } from 'vuex'
import * as storeFun from "./storeFun"
import { getremindtaskbar } from '@/port/mission/index'
import { getnewuserbindmsg } from '@/port/clientSide/multipleChoice.js'
import { getusertiplist } from '@/port/admins/organizationUser'
import { cloneDeep } from "lodash"

//保存数据
const state = {
  postUrl: [],
  heightAuto: 1, //高度监听
  formWidgetDataStore: null,//表单设计里的控件数据
  formWidgetDataPower: null,//表单设计里设置好权限的控件数据
  formWidgetPowerSetDataTitle: {
    editIsArr: [],
    readOnly: [],
    lookHide: [],
    isShowArr: [],
    printArr: [],
  },
  formWidgetPowerSetStateObj: {
    isEdit: false,
    isRead: false,
    isHide: false,
    isShow: false,
    isPrin: false,
  },
  formWidgetPowerSetStateObjStype: {},
  originatorState: true, //当前类型。是否为发起
  bulkImportMutat: true,//全校数据true
  isOnlyTitle: false, //发起时的唯一性标题
  isNewsCount: false, // 是否接收到新消息
  // 以下是数据工坊
  isDrage: false, // 是否打开配置
  drage: [],  // 拖拽出来的节点数据
  activedIndex: 0,//- 首页等nav选中的index
  // 任务系统 -- 红点数据 --
  taskHint: {
    count: 0,
    appid: ''
  },
  // 填写表单临时token
  temporaryToken: '',
  registerconfig: {},
  userData: {}, // 当前用户的详细信息
  doorCustomData: [], // 当前门户使用到的自定义数据
  doorCustomDataObj: {}, // 每个门户用到的自定义数据
  dashboardCustomData: [], // 仪表盘的自定义数据
  dashboardCustomDataObj: {}, // 每个仪表盘用到的自定义数据
  dashboardAppCustomData: [], // 仪表盘移动端的自定义数据
  reportCustomData: [], // 工坊的自定义数据
  aiTableData: [], // ai-数据表格获取选中数据
  userTipList: [], // 用户标签
};
//修改数据。是方法
const mutations = {
  // 修改仪表盘自定义变量
  changeDashboardCustomDataObj (state, { id, value }) {
    state.dashboardCustomDataObj[id] = value
  },
  // 修改门户自定义变量
  changeDoorCustomDataObj (state, { id, value }) {
    state.doorCustomDataObj[id] = value
  },
  // 修改自定义变量
  changeCustomData (state,  { key, value }) {
    state[`${key}CustomData`] = value
  },
  // 修改用户的信息
  changeUserData (state, newData) {
    state.userData = newData
  },
  // 修改用户标签信息
  changeUserTipList (state, newData) {
    state.userTipList = newData
  },
  // 任务获取红点
  async getTaskHint(state, val) {
    const { approvalId, upaceId } = val || {}
    const obj = {
      type: 1,
      status: 0
    }
    if (approvalId && approvalId !== 0) {
      obj.approvalId = approvalId
    }
    if (upaceId) {
      obj.upaceid = upaceId
    }
    const res = await getremindtaskbar(obj);
    if (res.code === 0) {
      state.taskHint = {
        count: res.data,
        appid: val
      }
    }
  },
  // 数据工坊 -- stat --
  isDrage(state, msg) {
    state.isDrage = msg;
  },
  upDrage(state, msg) {
    state.drage = msg;
  },
  // 数据工坊 -- end --
  upNewsCount(state, msg) {
    state.isNewsCount = msg;
  },
  upOnly(state, msg) {
    console.log('更新', state, msg)
    state.isOnlyTitle = msg;
  },
  //导入是个人还是全校判断
  bulkImportMutat(state, msg) {
    state.bulkImportMutat = msg;
  },
  //url检测
  upUrl(state, msg) {
    // console.log('添加拦截url', msg)
    state.postUrl.push(msg)
  },
  delUrl(state, msg) {
    // console.log('删除拦截url', msg)
    let date = JSON.parse(JSON.stringify(state.postUrl));
    let len = date.indexOf(msg);
    if (len !== -1) {
      date.splice(len, 1)
      state.postUrl = date
      // console.log('删除拦截', msg, state.postUrl)
    } else {
      // console.log('没有找到拦截', msg, state.postUrl)
    }
  },
  // 默认state相当于上面的state。msg参数
  editHeightAutoFun(state, msg) {
    state.heightAuto = msg;
  },
  /*************************表单设计--开始*************************/
  formWidgetDataStoreFun(state, msg) {
    state.formWidgetDataStore = msg;
  },
  formWidgetDataPowerFun(state, msg) {
    state.formWidgetDataPower = msg;
  },
  //表单权限设置响应。流程
  formWidgetSetPowerMVC(state, msgObj) {
    //msgObj.isCtoCo:1流程或者告知,
    storeFun.formWidgetSetPowerMVCGo1(state, msgObj);
    if (state.originatorState) {
      state.formWidgetPowerSetStateObjStype = JSON.parse(JSON.stringify(state.formWidgetPowerSetStateObj));
    }
    //console.log("23456iop="+JSON.stringify(state.formWidgetPowerSetStateObj));
    mutations.formWidgetPowerSetDataFun(state);//每一次置空
  },
  // 任务评审的分类
  ifyListArr(state, msg) {
    state.ifyListArr = msg;
  },
  //置空
  formWidgetPowerSetDataFun(state) {
    state.formWidgetPowerSetDataTitle.editIsArr = [];
    state.formWidgetPowerSetDataTitle.readOnly = [];
    state.formWidgetPowerSetDataTitle.lookHide = [];
    state.formWidgetPowerSetDataTitle.isShowArr = [];
    state.formWidgetPowerSetDataTitle.printArr = [];
  },
  originatorStateFun(state, msg) {
    state.originatorState = msg;
  },
  //- activedIndex选择函数
  changeSelect(state, val) {
    state.activedIndex = val
  },
  changeTemporaryToken(state, val) {
    state.temporaryToken = val
  },
  setRegisterConfig(state, val) {
    state.registerconfig = val
  },
  // ai-数据表格获取选中数据
  getTableData(state, val) {
    state.aiTableData = val
  },
  /*************************表单设计--结束*************************/
};
const actions = {
  async setAsyncUserData (context) {
    const userData = context.state.userData
    let userMsg = localStorage.getItem('userMsg')
    if (userMsg) {
      // 存在就不要请求了,
      userMsg = JSON.parse(userMsg)
      if (userData.userId === userMsg.userId) return false
      const { code, data } = await getnewuserbindmsg({ userId: userMsg.userId })
      // 处理一下部门相关的数据
      for (const key in data) {
        if ((key === 'orgname' || key.search('部门') !== -1) && Array.isArray(data[key])) {
          if (key === 'orgname') {
            data.orgList = cloneDeep(data[key])
          }
          data[key] = data[key].map(item => { return item.name }).join(',')
        }
      }
      if (code === 0) {
        const res = await getusertiplist({ curpage: 0, pagesize: 0 })
        if (res.code === 0) {
          const userTip = res.data.find(item => { return data.type === item.keytype })
          if (userTip) {
            data.typeLable = userTip.name
          }
          context.commit('changeUserTipList', res.data);
        }
        context.commit('changeUserData', data);
      }
    }
  }
};
export default createStore({
  state,
  mutations: mutations,
  actions: actions,
});
